<template>
  <div class="frame cooperation-profile">
    <!-- 搜索条件 -->
    <el-form
      :model="queryParams"
      label-width="120px"
      class="index-form-inline search-block"
    >
      <el-row :gutter="12">
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="业务类型">
            <el-input
              v-model="queryParams.businessType"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="姓名">
            <el-input
              v-model="queryParams.name"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="12">
          <el-form-item label-width="0px" class="search-actions">
            <el-button type="primary" icon="el-icon-search" @click="onSearch" />
            <el-button type="warning" @click="resetQuery">重置</el-button>
            <el-button
              type="text"
              class="search-toggle"
              @click="searchExpanded = !searchExpanded"
            >
              <i
                :class="
                  searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "
              />
              {{ searchExpanded ? "收起条件" : "展开全部条件" }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="searchExpanded" :gutter="12" class="search-extra-row">
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="目的地">
            <el-input
              v-model="queryParams.destination"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="应聘职位">
            <el-input
              v-model="queryParams.jobPost"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="性别">
            <el-input
              v-model="queryParams.gender"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="合作等级">
            <el-select
              v-model="queryParams.interviewerLevel"
              clearable
              placeholder="全部"
              style="width: 100%"
            >
              <el-option
                v-for="item in interviewerLevelOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="相关从业年限">
            <el-input
              v-model="queryParams.relevantExperienceYears"
              clearable
              placeholder="年，如 8"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="年度销售额">
            <el-input
              v-model="queryParams.annualSales"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="月均销售额">
            <el-input
              v-model="queryParams.averageMonthlySales"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="年度净业绩">
            <el-input
              v-model="queryParams.annualNetPerformance"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="最高净业绩">
            <el-input
              v-model="queryParams.highestNetPerformance"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="最高转化率">
            <el-input
              v-model="queryParams.highestConversionRate"
              clearable
              placeholder="如 85.50 表示 85.50%"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="最高毛利率">
            <el-input
              v-model="queryParams.highestGrossMargin"
              clearable
              placeholder="如 22.50 表示 22.50%"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table
      :data="tableRows"
      v-loading="loading"
      border
      stripe
      :max-height="YinnerHeight"
      style="width: 100%"
    >
      <el-table-column
        type="index"
        :index="tableRowIndex"
        label="序号"
        width="56"
        fixed
      />
      <el-table-column prop="name" label="姓名" width="100" fixed />
      <el-table-column prop="gender" label="性别" width="72" align="center" />
      <el-table-column
        prop="jobPost"
        label="应聘职位"
        min-width="110"
        align="center"
      />
      <el-table-column
        prop="cooperationTime"
        label="合作时间"
        min-width="160"
        align="center"
      />
      <el-table-column
        prop="interviewerLevel"
        label="合作等级"
        width="96"
        align="center"
      />
      <el-table-column
        prop="interviewerStatus"
        label="合作状态"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.interviewerStatus === 0 ? "待合作" : "合作中" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="businessType"
        label="业务类型"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="destination"
        label="目的地"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="relevantExperienceYears"
        label="相关从业年限"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.relevantExperienceYears }}年
        </template>
      </el-table-column>
      <el-table-column
        prop="annualSales"
        label="年度销售额"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="averageMonthlySales"
        label="月均销售额"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="annualNetPerformance"
        label="年度净业绩"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="highestNetPerformance"
        label="最高净业绩"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="highestConversionRate"
        label="最高转化率"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.highestConversionRate }}%
        </template>
      </el-table-column>
      <el-table-column
        prop="highestGrossMargin"
        label="最高毛利率"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.highestGrossMargin }}%
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="openEdit(scope.row)">修改</el-button>
          <el-button
            type="text"
            style="color: #e6a23c"
            :loading="cancelCooperateLoadingId === scope.row.id"
            @click="handleCancelCooperate(scope.row)"
          >
            取消合作
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
          <el-button type="text" @click="goToDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      :current-page="queryParams.pageIndex"
      :page-size="queryParams.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange"
    />

    <el-dialog
      title="修改合作信息"
      width="800px"
      :visible.sync="editVisible"
      class="form-dialog"
      :close-on-click-modal="false"
      @closed="onEditDialogClosed"
    >
      <el-form
        ref="editFormRef"
        :model="editForm"
        :rules="editRules"
        label-width="140px"
        class="profile-form"
      >
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="gender">
              <el-input v-model="editForm.gender" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应聘职位" prop="jobPost">
              <el-input v-model="editForm.jobPost" placeholder="如：旅游顾问" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合作时间" prop="cooperationTime">
              <el-date-picker
                v-model="editForm.cooperationTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择合作时间"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合作等级" prop="interviewerLevel">
              <el-select
                v-model="editForm.interviewerLevel"
                placeholder="请选择合作等级"
                style="width: 100%"
              >
                <el-option
                  v-for="item in interviewerLevelOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="相关从业年限" prop="relevantExperienceYears">
              <el-input
                v-model="editForm.relevantExperienceYears"
                placeholder="年，如 8"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="业务类型" prop="businessType">
              <el-input
                v-model="editForm.businessType"
                placeholder="如：高端定制游 · 小团私家"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="目的地" prop="destination">
              <el-input
                v-model="editForm.destination"
                placeholder="如：西欧（法瑞意）"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年度销售额" prop="annualSales">
              <el-input
                v-model="editForm.annualSales"
                placeholder="如：¥1,280万"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="月均销售额" prop="averageMonthlySales">
              <el-input
                v-model="editForm.averageMonthlySales"
                placeholder="请输入数字"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年度净业绩" prop="annualNetPerformance">
              <el-input
                v-model="editForm.annualNetPerformance"
                placeholder="如：¥186万"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最高净业绩" prop="highestNetPerformance">
              <el-input
                v-model="editForm.highestNetPerformance"
                placeholder="请输入数字"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最高转化率" prop="highestConversionRate">
              <el-input
                v-model="editForm.highestConversionRate"
                placeholder="如 85.50 表示 85.50%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最高毛利率" prop="highestGrossMargin">
              <el-input
                v-model="editForm.highestGrossMargin"
                placeholder="如 22.50 表示 22.50%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitEdit">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getJobList, updateJob, delJob } from "../util/api/job";

/** 合作库列表固定查询已合作数据 */
const LIST_INTERVIEWER_STATUS = 1;

export default {
  name: "CooperationLib",
  data() {
    const required = { required: true, message: "请填写", trigger: "blur" };
    return {
      loading: false,
      submitLoading: false,
      cancelCooperateLoadingId: null,
      searchExpanded: false,
      interviewerLevelOptions: ["初级", "中级", "高级"],
      queryParams: this.emptyQueryParams(),
      tableRows: [],
      total: 0,
      editVisible: false,
      editForm: this.emptyProfileForm(),
      editRules: {
        name: [required],
        jobPost: [required],
        businessType: [required],
        gender: [required],
        destination: [required],
        cooperationTime: [
          { required: true, message: "请选择合作时间", trigger: "change" },
        ],
        interviewerLevel: [
          { required: true, message: "请选择合作等级", trigger: "change" },
        ],
        relevantExperienceYears: [required],
        annualSales: [required],
        averageMonthlySales: [required],
        annualNetPerformance: [required],
        highestNetPerformance: [required],
        highestConversionRate: [required],
        highestGrossMargin: [required],
      },
      YinnerHeight: window.innerHeight - 320,
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    parseListResponse(res) {
      if (!res || Number(res.code) !== 0) {
        return { rows: [], total: 0 };
      }
      const d = res.data;
      if (d == null) {
        return { rows: [], total: 0 };
      }
      if (Array.isArray(d)) {
        return { rows: d, total: d.length };
      }
      const rows = d.records ?? d.list ?? d.rows ?? d.data ?? [];
      const list = Array.isArray(rows) ? rows : [];
      const total = d.total ?? d.count ?? list.length;
      return { rows: list, total: Number(total) || 0 };
    },
    emptyQueryParams(pageSize = 10) {
      return {
        pageIndex: 1,
        pageSize,
        id: "",
        businessType: "",
        name: "",
        jobPost: "",
        gender: "",
        destination: "",
        interviewerLevel: "",
        relevantExperienceYears: "",
        annualSales: "",
        averageMonthlySales: "",
        annualNetPerformance: "",
        highestNetPerformance: "",
        highestConversionRate: "",
        highestGrossMargin: "",
      };
    },
    emptyProfileForm() {
      return {
        id: "",
        name: "",
        interviewerStatus: LIST_INTERVIEWER_STATUS,
        jobPost: "",
        gender: "",
        cooperationTime: "",
        interviewerLevel: "",
        businessType: "",
        destination: "",
        relevantExperienceYears: "",
        annualSales: "",
        averageMonthlySales: "",
        annualNetPerformance: "",
        highestNetPerformance: "",
        highestConversionRate: "",
        highestGrossMargin: "",
      };
    },
    numberFieldKeys() {
      return [
        "relevantExperienceYears",
        "annualSales",
        "averageMonthlySales",
        "annualNetPerformance",
        "highestNetPerformance",
        "highestConversionRate",
        "highestGrossMargin",
      ];
    },
    appendStringQuery(params, q, keys) {
      keys.forEach((key) => {
        const v = q[key];
        if (v !== undefined && v !== null && String(v).trim() !== "") {
          params[key] = String(v).trim();
        }
      });
    },
    appendNumberQuery(params, q, keys) {
      keys.forEach((key) => {
        const v = q[key];
        if (v === "" || v === null || v === undefined) return;
        const num = Number(v);
        if (!Number.isNaN(num)) params[key] = num;
      });
    },
    tableRowIndex(index) {
      const { pageIndex, pageSize } = this.queryParams;
      return (pageIndex - 1) * pageSize + index + 1;
    },
    buildListQueryParams() {
      const q = this.queryParams;
      const params = {
        pageIndex: q.pageIndex,
        pageSize: q.pageSize,
        interviewerStatus: LIST_INTERVIEWER_STATUS,
      };
      this.appendStringQuery(params, q, [
        "id",
        "businessType",
        "name",
        "jobPost",
        "gender",
        "destination",
        "interviewerLevel",
      ]);
      this.appendNumberQuery(params, q, this.numberFieldKeys());
      return params;
    },
    buildUpdatePayload() {
      const f = this.editForm;
      const payload = {
        id: f.id,
        name: f.name,
        jobPost: f.jobPost,
        gender: f.gender,
        cooperationTime: f.cooperationTime,
        interviewerLevel: f.interviewerLevel,
        interviewerStatus: LIST_INTERVIEWER_STATUS,
        businessType: f.businessType,
        destination: f.destination,
      };
      this.numberFieldKeys().forEach((key) => {
        const v = f[key];
        if (v === "" || v === null || v === undefined) return;
        const num = Number(v);
        if (!Number.isNaN(num)) payload[key] = num;
      });
      return payload;
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await getJobList(this.buildListQueryParams());
        const { rows, total } = this.parseListResponse(res);
        this.tableRows = rows;
        this.total = total;
      } catch (e) {
        this.tableRows = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.queryParams.pageIndex = 1;
      this.fetchList();
    },
    resetQuery() {
      const pageSize = this.queryParams.pageSize;
      Object.assign(this.queryParams, this.emptyQueryParams(pageSize));
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.fetchList();
    },
    goToDetail(row) {
      const routeData = this.$router.resolve({
        path: "/interview/detail",
        query: { id: String(row.interviewId) },
      });
      window.open(routeData.href, "_blank");
    },
    openEdit(row) {
      this.editForm = { ...this.emptyProfileForm(), ...row };
      this.editVisible = true;
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.clearValidate();
        }
      });
    },
    onEditDialogClosed() {
      this.editForm = this.emptyProfileForm();
      if (this.$refs.editFormRef) {
        this.$refs.editFormRef.clearValidate();
      }
    },
    submitEdit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        this.submitLoading = true;
        try {
          const res = await updateJob(this.buildUpdatePayload());
          if (Number(res.code) !== 0) return;
          this.$notify.success({ title: "已保存", message: "合作信息已更新" });
          this.editVisible = false;
          this.fetchList();
        } finally {
          this.submitLoading = false;
        }
      });
    },
    /** 取消合作：状态改回未合作，清空合作时间与等级 */
    async handleCancelCooperate(row) {
      if (!row.id) {
        this.$message.warning("缺少记录 ID，无法取消合作");
        return;
      }
      try {
        await this.$confirm(
          `确定取消与「${
            row.name || "该记录"
          }」的合作吗？取消后将回到人才库待合作列表。`,
          "取消合作",
          {
            type: "warning",
            confirmButtonText: "确定取消",
            cancelButtonText: "暂不",
          }
        );
      } catch {
        return;
      }
      this.cancelCooperateLoadingId = row.id;
      try {
        const res = await updateJob({
          id: row.id,
          interviewerStatus: 0,
          cooperationTime: "",
          interviewerLevel: "",
        });
        if (Number(res.code) !== 0) return;
        this.$notify.success({ title: "已取消", message: "已取消合作" });
        if (this.tableRows.length <= 1 && this.queryParams.pageIndex > 1) {
          this.queryParams.pageIndex -= 1;
        }
        this.fetchList();
      } finally {
        this.cancelCooperateLoadingId = null;
      }
    },
    handleDelete(row) {
      if (!row.id) {
        this.$message.warning("缺少记录 ID，无法删除");
        return;
      }
      this.$confirm(
        `确定删除「${row.name || "该记录"}」的合作信息吗？`,
        "提示",
        {
          type: "warning",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(async () => {
          const res = await delJob({ id: row.id });
          if (Number(res.code) !== 0) return;
          this.$notify.success({ title: "已删除", message: "删除成功" });
          if (this.tableRows.length <= 1 && this.queryParams.pageIndex > 1) {
            this.queryParams.pageIndex -= 1;
          }
          this.fetchList();
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.cooperation-profile .pagination {
  margin-top: 16px;
  text-align: right;
}
.search-block .el-form-item {
  margin-bottom: 12px;
}
.search-actions {
  text-align: left;
}
.search-toggle {
  margin-left: 4px;
  margin-right: 4px;
  padding-left: 8px;
  padding-right: 8px;
}
.search-toggle i {
  margin-right: 4px;
}
.search-extra-row {
  margin-top: 4px;
}
</style>

<style>
.form-dialog .el-dialog__body {
  padding-top: 10px;
}
.profile-form .el-form-item {
  margin-bottom: 18px;
}
</style>
